import script from "./SidebarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarItem.vue?vue&type=style&index=0&id=ee8d5860&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=ee8d5860&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee8d5860"]])

export default __exports__